import { SideBar, SidebarGroup } from '@epo/epods-react-components/lib/Components/Sidebar';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import NavItem from './components/NavItem';

interface Props {
    children: ReactElement;
}

const WrappedSidebar = (props: Props): ReactElement => {
    const [t] = useTranslation();
    const { children } = props;
    const sidebarWidthExpanded = 250;
    const sidebarCollabsedWidth = 50;
    const [isCollapsed, setCollapsed] = React.useState(false);

    return (
        <div
            className="epo-gsb-dd epo-gsb-de epo-gsb-c7 epo-gsb-df"
            style={{
                display: 'flex',
                height: '100%',
                paddingTop: '60px',
            }}
        >
            <div
                className="epo-gsb-dg epo-gsb-dh"
                style={{
                    position: 'fixed',
                    height: '100%',
                    transition: 'all 0.2s ease',
                }}
            >
                <SideBar
                    collapseButtonPlacement="top"
                    hideCollapseButton={true}
                    onIsCollapsedChange={(collapsed) => setCollapsed(collapsed)}
                    size="default"
                    defaultIsCollapsed={isCollapsed}
                    widthExpanded={`${sidebarWidthExpanded}px`}
                >
                    <SidebarGroup aria-label="Actions" className="border-bottom border-top border-light">
                        <NavItem to="/" label={t("MENU::SEARCH")} icon="search" />
                        <NavItem to="/data-coverage" label={t("MENU::DATA_COVERAGE")} icon="streetview" />
                        <NavItem to="/about" label={t("MENU::ABOUT")} icon="account_balance" />
                        <NavItem to="/help" external label={t("MENU::HELP")} icon="help" />
                    </SidebarGroup>
                </SideBar>
            </div>
            <div
                style={{
                    width: '100%',
                    transition: 'all 0.2s ease',
                    paddingLeft: `${isCollapsed ? sidebarCollabsedWidth : sidebarWidthExpanded}px`,
                }}
            >
                <div style={{ padding: '25px 55px' }}>{children}</div>
            </div>
        </div>
    );
};

export default WrappedSidebar;
